import { Controller } from '@hotwired/stimulus'

// Shows the SASL and SSL fields only for protocols that use them and previews the topics the prefix makes.
export default class extends Controller {
  static targets = ['protocol', 'sasl', 'ssl', 'prefix', 'topic']

  connect () {
    this.toggle()
    this.preview()
  }

  toggle () {
    const sasl = this.protocolTarget.value.startsWith('SASL_')
    const ssl = this.protocolTarget.value.endsWith('SSL')

    this.saslTargets.forEach((target) => {
      target.hidden = !sasl
    })
    this.sslTargets.forEach((target) => {
      target.hidden = !ssl
    })
  }

  preview () {
    this.topicTargets.forEach((target) => {
      target.textContent = `${this.prefixTarget.value}${target.dataset.stream}`
    })
  }
}
